import React from 'react';
import { Form } from 'react-bootstrap';
import ThInputText from './th-input-text';
import Button from '../UI/button';
import { useEditActivity } from '../modals/activity/use-edit-activity';

type Props = {
  activityId: string;
  tripId: string;
  destinationId?: string;
  onSuccess: () => void;
};

function EditActivityForm({
  activityId,
  tripId,
  destinationId,
  onSuccess
}: Props) {
  const { activity, validated, handleInputChange, handleSubmit } =
    useEditActivity(activityId, tripId, destinationId, onSuccess);

  if (!activity) {
    return <p>Loading...</p>;
  }

  return (
    <Form onSubmit={handleSubmit}>
      <ThInputText
        mb={24}
        label='Title'
        required
        value={activity.title}
        placeholder='Enter title'
        onChange={(value) => handleInputChange('title', value)}
      />
      <ThInputText
        mb={24}
        label='Description'
        value={activity.description}
        placeholder='Enter description'
        onChange={(value) => handleInputChange('description', value)}
      />
      <ThInputText
        mb={24}
        label='Website Link'
        value={activity.websiteUrl ?? ''}
        placeholder='Enter website link'
        onChange={(value) => handleInputChange('websiteUrl', value)}
      />
      <ThInputText
        mb={24}
        label='Image URL'
        value={activity.imageUrl}
        placeholder='Enter image URL'
        onChange={(value) => handleInputChange('imageUrl', value)}
      />
      <ThInputText
        mb={24}
        label='Add Note'
        placeholder='Enter a new note'
        value=''
        onChange={(value) => {
          handleInputChange('newNote', value);
        }}
      />

      <div
        style={{
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '8px',
          minHeight: '80px',
          marginBottom: '24px',
          whiteSpace: 'pre-wrap',
          overflowY: 'auto',
          backgroundColor: '#f9f9f9'
        }}
      >
        {activity.notes && activity.notes.length > 0 ? (
          activity.notes.map((note, index) => (
            <p
              key={index}
              style={{ marginBottom: '4px' }}
            >
              {note}
            </p>
          ))
        ) : (
          <p style={{ color: '#aaa', fontStyle: 'italic' }}>
            No notes added yet.
          </p>
        )}
      </div>
      <Form.Check
        type='checkbox'
        label='Is Public'
        checked={activity.isPublic}
        onChange={(e) => handleInputChange('isPublic', e.target.checked)}
      />
      <Button
        disabled={!validated}
        type='submit'
        width={167}
        className='mx-auto'
        style={{ marginTop: '24px' }}
      >
        Update
      </Button>
    </Form>
  );
}

export default EditActivityForm;
